import React, { useState, useEffect } from "react";
import {
  Switch,
  Route,
  useHistory,
  Redirect,
  useLocation,
} from "react-router-dom";
import { Layout, Avatar, Dropdown, Menu, Grid } from "antd";
import { orange } from "@ant-design/colors";

import { connect } from "react-redux";
import AuthService from "./services/AuthService";
import DashboardService from "./services/DashboardService";
import { fetchAdminRestaurant, setUserRestaurants } from "./action/index";

import R2Footer from "./components/Footer";
import HeaderMenu from "./components/HeaderMenu";
import SubHead from "./components/HeaderMenu/subHead";
import routes from "./components/routes";
import SignIn from "./pages/Public/EmployeSignIn";

import { Loader } from "react-feather";
import Rest_icon from "./assets/images/rest_icon.svg";
import Profile_icon from "./assets/images/profile_icon.svg";
import Logout_icon from "./assets/images/logout_icon.svg";
import CustomerWaitlist from "./pages/CustomerWaitlist";
import WaitingDetails from "./pages/CustomerWaitlist/WaitingDetails";
import Notification_Icon from "./assets/images/notification.svg";
import "./App.less";
import OTPPage from "./pages/Public/OTPPage";
import PublicCatering from "./pages/Catering/PublicCatering";
import ForgotPwd from "./pages/Public/ForgotPwd";
import { Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import MobileDrawerMenu from "./components/HeaderMenu/MobileDrawerMenu";

const { Header, Content } = Layout;
const { useBreakpoint } = Grid;

function App(props) {
  const [loading, setLoading] = useState(true);
  const [restaurants, setRestaurants] = useState([]);
  const [selectedResaturent, setSelectedRestaurant] = useState();
  const [userInitials, setUserInitials] = useState("");
  const location = useLocation();

  const history = useHistory();
  const screens = useBreakpoint();


  const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        userInitials ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );

  const PublicRoute = ({ component: Component, restricted, ...rest }) => (
    <Route {...rest} render={(props) => <Component {...props} />} />
  );

  // const menu = (
  // 	<Menu>
  // 		<div className="res_heading">Selected Restaurant</div>
  // 		<>
  // 		{restaurants &&
  // 			restaurants.map((item) => (
  // 				<Menu.Item key={item.id} className={selectedResaturent === item.name ? "active_res_item" : "rest_items"} onClick={()=>{onChange(item.name)}}>
  // 					{item.name}
  // 				</Menu.Item>
  // 			))}
  // 		</>
  // 		<Menu.Item key="0">View Profile</Menu.Item>
  // 		<Menu.Item key="1" onClick={AuthService.logout}>
  // 			Logout
  // 		</Menu.Item>
  // 	</Menu>
  // );
  AuthService.getLoggedInUser().then((loggedInUser) => {
    setLoading(false);
    if (loggedInUser) {
      const words = loggedInUser.split(" ");
      const userInitials = words.map((c) => c[0]).join("");
      setUserInitials(userInitials);
    } else {
      setUserInitials(null);
    }
  });
  useEffect(() => {
    if (userInitials) getAllRestarents();
    // checkLoggedInUser();
  }, [userInitials]);

  AuthService.getLoggedInUser().then((loggedInUser) => {
    setLoading(false);
    if (loggedInUser) {
      const words = loggedInUser.split(" ");
      const userInitials = words.map((c) => c[0]).join("");
      setUserInitials(userInitials);
    } else {
      setUserInitials(null);
    }
  });
  useEffect(() => {
    if (userInitials) getAllRestarents();
    if (!window.location.pathname.includes("/public")) checkLoggedInUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInitials]);

  const checkLoggedInUser = () => {
    let token = localStorage.getItem("token");
    if (!(window.location.href + "").includes("/catering-request") && !token) {
      history.push("/");
    }
  };

  const appRoutes = routes.reduce((_routes, r, i) => {
    const RouteComponent = r.isPublic ? (
      <PublicRoute
        exact
        key={`${i}-${r.path}`}
        path={r.path}
        component={r.component}
      />
    ) : (!r.showInHeader && !r.showin_more) || r.path === "/kds" ? (
      <PrivateRoute
        exact={!r.matchNonExact}
        key={`${i}-${r.path}`}
        path={r.path}
        component={r.component}
      />
    ) : null;
    let mainRoutes = _routes.concat(RouteComponent);
    if (r.subMenus) {
      mainRoutes = mainRoutes.concat(
        r.subMenus.map((subRoute, i) => (
          <PrivateRoute
            exact
            key={`${i}-${subRoute.path}`}
            path={`${r.path}${subRoute.path}`}
            component={subRoute.component}
          />
        ))
      );
    }
    return mainRoutes;
  }, []);

  const getAllRestarents = async () => {
    const getRestaurants = await DashboardService.getRestaurantsByUser();
    setRestaurants(getRestaurants);
    setSelectedRestaurant(getRestaurants && getRestaurants[0].id);
    if (getRestaurants) {
      localStorage.setItem("restaurantId", getRestaurants[0].id);
      props.fetchAdminRestaurant(getRestaurants[0].id);
      props.setUserRestaurants(getRestaurants);
    }
  };

  function onChange(value) {
    setSelectedRestaurant(value);
    localStorage.setItem("restaurantId", value);
    props.fetchAdminRestaurant(value);
  }

  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="App">
      {loading ? (
        <Loader />
      ) : !(window.location.href + "").includes("/catering-request") &&
        userInitials ? (
        <Layout>
          <Header className="header" style={{ backgroundColor: "#302f2f" }}>

            <div className="mobile_menu_icon">
    <MenuOutlined onClick={() => setDrawerOpen(true)} />
  </div>

            <Drawer
  placement="left"
  open={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  bodyStyle={{ padding: 0 }}
  width={280}
  className="mobile-menu-drawer"
  title={<div className="logo">
              <img src="/images/logo.svg" alt="Logo" />
            </div>}
>
  <MobileDrawerMenu closeDrawer={() => setDrawerOpen(false)} />
</Drawer>


            <div className="logo">
              <img src="/images/logo.svg" alt="Logo" />
            </div>
            <div className="desktop_menu">
              <HeaderMenu location={location} />
            </div>
            <div className="menu bg-red" style={{ marginLeft: "auto" }}>
              <div className="flex cursor-pointer" style={{ marginRight: 20 }}>
                <img src={Notification_Icon} alt="notification" />
              </div>
              <Dropdown
                overlay={
                  <Menu style={{ borderRadius: 12, marginTop: 4 }}>
                    <Menu.Item key="2">
                      <div className="res_heading">
                        <img src={Rest_icon} alt="res" />
                        Selected Restaurant
                      </div>
                    </Menu.Item>
                    <>
                      {restaurants &&
                        restaurants.map((item) => (
                          <Menu.Item
                            key={item.id}
                            className={
                              selectedResaturent === item.id
                                ? "active_res_item"
                                : "rest_items"
                            }
                            onClick={() => {
                              onChange(item.id);
                            }}
                          >
                            <div className="res_dot"> </div>
                            {item.name}
                          </Menu.Item>
                        ))}
                    </>
                    <Menu.Item key="0">
                      <div className="res_heading">
                        <img src={Profile_icon} alt="res" /> View Profile
                      </div>
                    </Menu.Item>
                    <Menu.Item key="1" onClick={AuthService.logout}>
                      <div className="res_heading">
                        <img src={Logout_icon} alt="res" /> Logout
                      </div>
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <Avatar
                  style={{ backgroundColor: orange[5], marginRight: 10 }}
                  gap={4}
                  className="cursor-pointer"
                >
                  {userInitials}
                </Avatar>
              </Dropdown>
            </div>
          </Header>
          {screens.md &&
          <SubHead location={location} />
}
          <Layout style={{ minHeight: "calc(100vh - 110px )" }}>
            {location.pathname.includes("/pos/menus") ? (
              // "<SidePosMenu />"
              ""
            ) : location.pathname.includes("/pos/checkout") ? (
              ""
            ) : (
              <>{/* <SideMenu /> */}</>
            )}
            <Switch>
              {appRoutes}
              
              <Redirect exact from="/" to="/dashboard/kpi" />
              <Redirect from="/dashboard" to="/dashboard/kpi" />
              <Redirect from="/orders" to="orders/orders" />
              <Redirect from="/kds" to="/kds/expo" />
              <Redirect from="/menu" to="/menu/list" />
              <Redirect from="/pos" to="/pos/dashboard" />
              <Redirect from="/delivery" to="/delivery/manage-orders" />
              <Redirect from="/business" to="/business/my-business" />
              <Redirect from="/website" to="/website/theme" />
              <Redirect from="/catering" to="/catering/dashboard" />
              <Redirect from="/settings" to="/settings/team-member" />
              <Redirect from="/employee" to="/employee/all" />
              <Redirect
                from="/foodluv-trial"
                to="/foodluv-trial/business-profile"
              />
            </Switch>
          </Layout>
        </Layout>
      ) : (
        <Layout className="login-layout">
          {!(window.location.href + "").includes("/catering-request") && (
            <Header className="header" style={{ backgroundColor: "#302f2f" }}>
              <div className="logo">
                <img src="/images/logo.svg" alt="FoodLuv" />
              </div>
            </Header>
          )}
          <Content>
            <Switch>
              <PublicRoute
                exact
                path="/restaurant/:restaurantCode/waitlist"
                component={CustomerWaitlist}
              />
              <PublicRoute exact path="/public/verify" component={OTPPage} />
              <PublicRoute
                exact
                path="/restaurant/:restaurantCode/waitlist/:id"
                component={WaitingDetails}
              />
              <PublicRoute
                exact
                path="/catering-requests/:code"
                component={PublicCatering}
              />
              <Route exact path="/forgot-password" component={ForgotPwd} />

              <Route exact path="/" component={SignIn} />
            </Switch>
          </Content>
          {!(window.location.href + "").includes("/catering-request") && (
            <R2Footer color="#FEF2F1" />
          )}
        </Layout>
      )}
    </div>
  );
}

const mapDispatchToProps = {
  fetchAdminRestaurant,
  setUserRestaurants,
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
